(function () {
  'use strict';

  var form = document.getElementById('contact-form');
  if (!form) return;

  var submitBtn = form.querySelector('.btn-submit');
  if (!submitBtn) return;
  var originalBtnText = submitBtn.textContent;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    sendForm();
    return false;
  });

  // Belt-and-suspenders: block any native submit that bypasses the listener
  form.onsubmit = function () { return false; };

  function sendForm() {
    clearMessage();
    submitBtn.disabled = true;
    submitBtn.textContent = 'Wysyłanie…';

    var data = new FormData(form);

    fetch('send.php', {
      method: 'POST',
      body: data,
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, body: json };
        });
      })
      .then(function (result) {
        if (result.ok && result.body.success) {
          showMessage('success', result.body.message || 'Wiadomość wysłana pomyślnie!');
          form.reset();
        } else {
          showMessage('error', result.body.message || 'Wystąpił błąd. Spróbuj ponownie.');
        }
      })
      .catch(function () {
        showMessage('error', 'Błąd połączenia. Sprawdź internet i spróbuj ponownie.');
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalBtnText;
      });
  }

  function showMessage(type, text) {
    var msg = form.querySelector('.form-message');
    if (!msg) {
      msg = document.createElement('div');
      form.appendChild(msg);
    }
    msg.className = 'form-message form-message--' + type;
    msg.textContent = text;
    msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearMessage() {
    var msg = form.querySelector('.form-message');
    if (msg) msg.remove();
  }
})();
